import React, { useEffect, useState, Suspense, lazy } from "react";
import "@fontsource/poppins";
import './App.css';
import MediaQuery from 'react-responsive';
import axios from "axios";
import Header from './components/Header';
import CallMeForm from './components/CallMeForm';
import Body from './components/Body';
import Footer from './components/FooterNew/index.js';
import Contact from './components/Contact';
import Pavan from './components/Pavan';
import CacheBuster from 'react-cache-buster';
import appversion from '../package.json';
import jsonData from "./ai-branding.json"; // Import the JSON file
import { CookieSetting } from "cookiesetting-component";
import { useHyperlink } from "./contexts/HyperlinkProvider.js";
 
function App() {


  const [links, setLinks] = useState(null); // Set initial state as null
  const appVersion = appversion.version;
  const [angelAiLink, setAngelAiLink] = useState("");
  const [angelComLink, setAngelComLink] = useState("");
  const [sunwestLink, setSunWestLink] = useState("");
  const [swmcLink, setSwmcLink] = useState("");
  const [celligenceLink, setCelligenceLink] = useState("");
  const [celligenceLlcLink, setCelligenceLlcLink] = useState("");
  const [pavanLink, setPavanLink] = useState("");
  const { getHyperLink } = useHyperlink();

  useEffect(() => {
    const processContent = async () => {
      const swLink = await getHyperLink("websites", "swmc", 0);
      const swmcLink = await getHyperLink("websites", "swmc", 1);
      const aiLink = await getHyperLink("websites", "angelai", 0);
      const aiComLink = await getHyperLink("websites", "angelai", 1);
      const cellLink = await getHyperLink("websites", "celligence", 1);
      const celliLlcLink = await getHyperLink("websites", "celligence", 0);
      const pavan = await getHyperLink("profiles", "pavan", 0);
      setAngelAiLink(aiLink || "AngelAi");
      setAngelComLink(aiComLink || "AngelAi.com");
      setSunWestLink(swLink || "Sun West");
      setSwmcLink(swmcLink|| "Sun West Mortgage Company, Inc.");
      setCelligenceLink(cellLink || "Celligence");
      setCelligenceLlcLink(celliLlcLink || "Celligence LLC");
      setPavanLink(pavan || "Pavan Agarwal");
    };
    processContent();
  }, [getHyperLink]);


  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);
  return (
    <>
    {/* <Navbar /> */}

    <CacheBuster
      currentVersion={appVersion}
      isEnabled ={true}
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      metaFileDirectory={'.'}
    >
    {links ? (
    <>
      <MediaQuery minWidth={992}>
      
        <Suspense fallback={<div />}>
        
          
          <div className="blue-bg">
            <Header links={links.current} pavanLink={pavanLink}/>
          </div>
          <div className="pavan-bg">
            <Pavan links={links.current} pavanLink={pavanLink} angelAiLink={angelAiLink} swmcLink={swmcLink}/>
          </div>
          <div className="form-8hours-bg">
            <Contact />
            <Body links={links.current} sunwestLink={sunwestLink} angelAiLink={angelAiLink}/>
          </div>
        </Suspense>
      </MediaQuery>

      <MediaQuery maxWidth={991}>
        <Suspense fallback={<div />}>
          <div className="blue-bg">
            <Header links={links.current} pavanLink={pavanLink}/>
          </div>
          <Pavan links={links.current} pavanLink={pavanLink} angelAiLink={angelAiLink} swmcLink={swmcLink}/>
          <div className="Contact-bg">
            <Contact />
          </div>
          <Body links={links.current} sunwestLink={sunwestLink} angelAiLink={angelAiLink} />
        </Suspense>
      </MediaQuery>

      <Footer />
      </>
    ) : (
      <div>Loading...</div>
    )}
    <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
    </CacheBuster>

    </>
  );
}

export default App;
